import { Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { anyU } from 'src/app/models/anyU';
import { environment } from 'src/environments/environment';
import { cookU } from 'src/app/models/cookU'; // مطمئن شوید که این مدل شامل food_Name, cook_Order, description و ... است
declare var bootstrap: any;

@Component({
  selector: 'app-cooking',
  templateUrl: './cooking.component.html',
  styleUrls: ['./cooking.component.css']
})
export class CookingComponent implements OnInit { // implements OnInit ضروری است

  baseUrl = environment.apiBaseUrl;
  @ViewChild('userModal') userModal: ElementRef | undefined;
  @ViewChild('detailModal') detailModal!: ElementRef;

  detailObj: any = null;
  searchText: string = '';
  filteredList: cookU[] = []; // نوع داده را cookU قرار دهید
  anyList: cookU[] = []; // نوع داده را cookU قرار دهید

  anyObj: cookU = { // نوع داده را cookU قرار دهید و مقداردهی اولیه مناسب انجام دهید
    "id": 0,
    "food_Name": "",
    "cook_Order": "",
    "description": "",
    "food_Type": "",
    
    // "image": "" // یا هر فیلد دیگری که در cookU تعریف شده است
  };

  http = inject(HttpClient);

  ngOnInit(): void {
    this.getAllcook();
  }

  openModal(): void {
    if (this.userModal) {
      const modal = new bootstrap.Modal(this.userModal.nativeElement);
      modal.show();
    }
  }

  closeModal(): void {
    if (this.userModal) {
      const modal = bootstrap.Modal.getInstance(this.userModal.nativeElement);
      if (modal) modal.hide();
    }
  }

  getAllcook(): void {
    this.http.get<cookU[]>(`${this.baseUrl}/cook`).subscribe((res) => {
      this.anyList = res;
      // وقتی داده‌ها دریافت می‌شوند، لیست فیلتر شده را با کل لیست اولیه برابر قرار دهید
      this.filteredList = [...this.anyList]; // استفاده از spread operator برای اطمینان از کپی شدن آرایه
      // console.log("Fetched and set anyList:", this.anyList);
      // console.log("Initial filteredList:", this.filteredList);
    });
  }

  onSearch(): void {
    const text = this.searchText.toLowerCase().trim();
    // console.log("Searching for:", text);

    if (!text) {
      // اگر متن جستجو خالی است، همه آیتم‌ها را نمایش بده
      this.filteredList = [...this.anyList];
      // console.log("Search text empty, resetting filteredList:", this.filteredList);
      return;
    }

    this.filteredList = this.anyList.filter(item =>
      // فرض می‌کنیم cookU شامل این فیلدهاست. اگر نام دقیق فیلدها فرق می‌کند، آن‌ها را اصلاح کنید.
      item.food_Name.toLowerCase().includes(text) ||
      item.cook_Order.toLowerCase().includes(text) ||
      item.description.toLowerCase().includes(text) || // اگر توضیحات هم قابل جستجو است
      item.food_Type.toLowerCase().includes(text)     // اگر نوع غذا هم قابل جستجو است
    );
    // console.log("Filtered list:", this.filteredList);
  }

  openDetailModal(item: cookU): void { // از cookU برای نوع داده استفاده کنید
    this.detailObj = item;
    const modal = new bootstrap.Modal(this.detailModal.nativeElement);
    modal.show();
  }

  // این متد `onSave1` به نظر تکراری می‌آید و ممکن است لازم نباشد.
  // اگر کارکرد متفاوتی دارد، لطفا توضیح دهید.
  // onSave1(): void {
  //   this.http.post<anyU>(`${this.baseUrl}/cook`, this.anyObj).subscribe({
  //     next: (res) => {
  //       this.getAllcook();
  //       this.closeModal();
  //     },
  //     error: (err) => {
  //       console.error("Error details:", err);
  //     }
  // });
  // }

  onSave(): void {
    if (this.anyObj.id === 0) {
      // افزودن
      // شناسه را قبل از ارسال حذف کنید مگر اینکه API آن را مدیریت کند
      const newItem = { ...this.anyObj };
      // delete newItem.id; // این خط مهم است اگر API انتظار ندارد ID را برای ایجاد بفرستید

      this.http.post<cookU>(`${this.baseUrl}/cook`, newItem).subscribe((res) => {
        this.getAllcook();
        this.closeModal();
        this.anyObj = { id: 0, cook_Order: "", description: "", food_Type: "", food_Name: " " }; // فرم را ریست کنید
      });
    } else {
      // ویرایش
      // API ویرایش شما در حال حاضر از POST با آدرس /cook/update استفاده می‌کند
      // که ممکن است استاندارد RESTful نباشد، اما طبق کد شما عمل می‌کنیم.
      this.http.post<cookU>(`${this.baseUrl}/cook/update`, this.anyObj).subscribe((res) => {
        this.getAllcook();
        this.closeModal();
        this.anyObj = { id: 0, cook_Order: "", description: "", food_Type: "", food_Name: " " }; // فرم را ریست کنید
      });
    }
  }

  openEditModal(user: cookU): void { // از cookU برای نوع داده استفاده کنید
    this.anyObj = { ...user }; // پر کردن فیلدها با داده‌های کاربر انتخاب‌شده
    this.openModal();
  }

  delete(Id: number): void {
    if (confirm("آیا مطمئن هستید که می‌خواهید این مورد را حذف کنید؟")) {
      this.http.post(`${this.baseUrl}/cook/delete/${Id}`, null).subscribe(() => {
        this.getAllcook();
      });
    }
  }

  fixUrl(url: string): string {
    if (!url) return '';
    if (url.startsWith('http://') || url.startsWith('https://')) {
      return url;
    }
    return 'http://' + url;
  }
}
